/* tslint:disable */
/* eslint-disable */
/**
 * UI schemas for iDeed ARCGx v2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyAmount
 */
export interface MoneyAmount {
    /**
     * 
     * @type {number}
     * @memberof MoneyAmount
     */
    units?: number;
    /**
     * 
     * @type {number}
     * @memberof MoneyAmount
     */
    nanos?: number;
    /**
     * 
     * @type {string}
     * @memberof MoneyAmount
     */
    currencyCode?: MoneyAmountCurrencyCodeEnum;
}


/**
 * @export
 */
export const MoneyAmountCurrencyCodeEnum = {
    XXX: 'XXX',
    EUR: 'EUR',
    GBP: 'GBP',
    AUD: 'AUD',
    NZD: 'NZD',
    FJD: 'FJD',
    TOP: 'TOP',
    WST: 'WST',
    PGK: 'PGK',
    BWP: 'BWP',
    SBD: 'SBD',
    USD: 'USD',
    SGD: 'SGD'
} as const;
export type MoneyAmountCurrencyCodeEnum = typeof MoneyAmountCurrencyCodeEnum[keyof typeof MoneyAmountCurrencyCodeEnum];


/**
 * Check if a given object implements the MoneyAmount interface.
 */
export function instanceOfMoneyAmount(value: object): boolean {
    return true;
}

export function MoneyAmountFromJSON(json: any): MoneyAmount {
    return MoneyAmountFromJSONTyped(json, false);
}

export function MoneyAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyAmount {
    if (json == null) {
        return json;
    }
    return {
        
        'units': json['units'] == null ? undefined : json['units'],
        'nanos': json['nanos'] == null ? undefined : json['nanos'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
    };
}

export function MoneyAmountToJSON(value?: MoneyAmount | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'units': value['units'],
        'nanos': value['nanos'],
        'currencyCode': value['currencyCode'],
    };
}

